import { Button, ButtonGroup, Spinner } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiRayStartArrow } from "@mdi/js";

type NavigationProps = {
	backLabel: string;
	nextLabel: string;
	saving?: boolean;
	onBack: () => void;
	onNext: () => void;
};

export default function Navigation({ backLabel, nextLabel, saving = false, onBack, onNext }: NavigationProps) {
	return (
		<div className="d-flex justify-content-center">
			<ButtonGroup size="lg" className="criteria-navigation shadow-sm flex-column flex-sm-row w-100" style={{ maxWidth: 360 }}>
				<Button
					variant="light"
					className="d-flex justify-content-center align-items-center gap-3 text-uppercase w-100"
					type="button"
					onClick={onBack}
					disabled={saving}
				>
					<Icon path={mdiRayStartArrow} size={1} style={{ transform: "scaleX(-1)" }} />
					{backLabel}
				</Button>
				<Button
					className="d-flex justify-content-center align-items-center gap-3 text-uppercase w-100"
					type="button"
					onClick={onNext}
					disabled={saving}
				>
					{saving ? (
						<><Spinner animation="border" size="sm" /> Salvando</>
					) : (
						<>{nextLabel} <Icon path={mdiRayStartArrow} size={1} /></>
					)}
				</Button>
			</ButtonGroup>
		</div>
	);
}
